import Boxform from './Boxform';
import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Cookies } from '../../../index.js';
import { alert_error, alert_success } from "../../../AppContext";
import { MyContext } from '../urlshorten_system/index'; // hoặc './Indexok'
import Check_done from './check_done.jsx';
import { RingLoader, MoonLoader } from "react-spinners";
function Checkstart() {
    const { step_service, setstep_service, caption, setcaption, show_link_done, setshow_link_done,
        link_done, setlink_done } = useContext(MyContext);

    function dichden() {
        window.open(link_done, "_blank");
    }
    return (
        <>
            <button
                onClick={dichden}
                className="mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-pink-400 dark:text-white border border-white ring-4 ring-purple-300 ring-offset-2 dark:ring-offset-gray-800"
            >
                <div className="flex items-center justify-between flex-1">
                    <span className="text-2xl font-bold py-1 text-white">
                        Nhấn đây truy cập liên kết bạn cần lấy
                    </span>
                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                </div>
            </button>
        </>
    );
}

export default Checkstart;